import type { ReactNode } from 'react';

import type { AssetLibraryDisplayItem } from '../utils';
import AssetLibraryCardThumbnailOverlay from './AssetLibraryCardThumbnailOverlay';
import AssetLibraryThumbnail from './AssetLibraryThumbnail';

const DEFAULT_SHELL_CLASS =
  'bg-tertiary relative h-full w-full overflow-hidden rounded-lg';

export interface AssetLibraryCardThumbnailShellProps {
  asset: AssetLibraryDisplayItem;
  embedded: boolean;
  isHovered: boolean;
  autoPlayVideo: boolean;
  isGroupDetailItem?: boolean;
  bulkSelectionEnabled?: boolean;
  showBookmark?: boolean;
  selected?: boolean;
  onClick?: () => void;
  onToggleSelection?: () => void;
  overlay?: ReactNode;
  className?: string;
}

export default function AssetLibraryCardThumbnailShell({
  asset,
  embedded,
  isHovered,
  autoPlayVideo,
  isGroupDetailItem = false,
  bulkSelectionEnabled = false,
  showBookmark = false,
  selected = false,
  onClick,
  onToggleSelection,
  overlay,
  className = DEFAULT_SHELL_CLASS,
}: AssetLibraryCardThumbnailShellProps) {
  return (
    <div className={className}>
      <AssetLibraryCardThumbnailOverlay
        asset={asset}
        embedded={embedded}
        isHovered={isHovered}
        isGroupDetailItem={isGroupDetailItem}
        bulkSelectionEnabled={bulkSelectionEnabled}
        showBookmark={showBookmark}
        selected={selected}
        onClick={onClick}
        onToggleSelection={onToggleSelection}
      />
      {overlay}
      <AssetLibraryThumbnail
        assetType={asset.assetType}
        thumbnailURL={asset.thumbnailURL}
        isHovered={isHovered}
        autoPlayVideo={autoPlayVideo}
      />
    </div>
  );
}
